function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_11_498)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M167.024 134.667L169.911 137.554L172.798 134.667L169.911 131.78L167.024 134.667ZM387.575 89.334L384.688 86.4472L381.801 89.334L384.688 92.2207L387.575 89.334ZM169.911 135.167C215.999 135.167 246.503 123.805 277.075 112.469C307.632 101.139 338.26 89.834 384.688 89.834V88.834C338.07 88.834 307.301 100.195 276.728 111.532C246.169 122.862 215.808 134.167 169.911 134.167V135.167Z",
  fill: "#6F7073"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_11_498)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M167.024 89.3337L169.911 86.447L172.798 89.3337L169.911 92.2205L167.024 89.3337ZM387.575 134.667L384.688 137.553L381.801 134.667L384.688 131.78L387.575 134.667ZM169.911 88.8337C215.999 88.8337 246.503 100.196 277.075 111.531C307.632 122.861 338.26 134.167 384.688 134.167V135.167C338.07 135.167 307.301 123.805 276.728 112.469C246.169 101.138 215.808 89.8337 169.911 89.8337V88.8337Z",
  fill: "#6F7073"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d_11_498)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M403.327 121.755V158.053C403.327 158.952 403.905 159.659 404.676 159.659H468.276C468.982 159.659 469.625 158.952 469.625 158.053V67.1473C469.625 66.2479 469.046 65.5412 468.276 65.5412L404.611 65.6697C403.905 65.6697 403.262 66.3763 403.262 67.2758V107.171C403.262 112.082 403.327 117.899 403.327 121.755Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.621 62.6015L404.461 62.731C402.324 62.731 400.511 64.6092 400.511 66.9409V130.69C400.511 131.403 400.558 131.986 401.27 131.986C401.982 131.986 402.072 131.403 402.072 130.69V66.8761C402.072 65.9535 403.044 64.2275 404.461 64.2275L468.621 64.098C470.089 64.098 471.01 65.8398 471.01 66.7466V158.392C471.01 159.633 469.571 161.04 468.621 161.04H404.525C403.537 161.04 402.136 159.741 402.136 158.392V121.798C402.136 121.086 402.062 120.503 401.35 120.503C400.59 120.503 400.576 121.086 400.576 121.798V158.392C400.576 160.723 402.324 162.601 404.525 162.601H468.621C470.757 162.601 472.57 160.723 472.57 158.392V133.91V66.8113C472.57 64.4797 470.822 62.6015 468.621 62.6015Z",
  fill: "white",
  fillOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.028 70.94C447.023 71.3268 447.133 71.7062 447.344 72.0302C447.556 72.3541 447.859 72.6079 448.215 72.7592C448.571 72.9106 448.964 72.9527 449.344 72.8802C449.723 72.8077 450.073 72.6239 450.348 72.3521C450.624 72.0803 450.812 71.7328 450.889 71.3538C450.966 70.9748 450.929 70.5814 450.782 70.2236C450.635 69.8657 450.385 69.5597 450.064 69.3443C449.743 69.1288 449.365 69.0138 448.978 69.0138C448.464 69.0116 447.971 69.2131 447.605 69.5741C447.239 69.9351 447.032 70.4263 447.028 70.94V70.94Z",
  fill: "#6F7073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454.631 70.94C454.626 71.3271 454.737 71.7069 454.949 72.031C455.16 72.3551 455.464 72.6089 455.82 72.76C456.177 72.9111 456.57 72.9528 456.95 72.8796C457.33 72.8065 457.68 72.6218 457.955 72.3492C458.23 72.0766 458.417 71.7284 458.494 71.3488C458.57 70.9693 458.532 70.5756 458.384 70.2179C458.236 69.8603 457.984 69.5547 457.662 69.3403C457.34 69.1259 456.961 69.0122 456.574 69.0138C456.061 69.0138 455.57 69.2162 455.206 69.577C454.842 69.9377 454.635 70.4277 454.631 70.94V70.94Z",
  fill: "#6F7073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M462.175 70.94C462.17 71.3268 462.28 71.7062 462.492 72.0302C462.703 72.3541 463.006 72.6079 463.362 72.7592C463.718 72.9106 464.111 72.9527 464.491 72.8802C464.871 72.8077 465.221 72.6239 465.496 72.3521C465.771 72.0803 465.959 71.7328 466.036 71.3538C466.114 70.9748 466.077 70.5814 465.93 70.2236C465.783 69.8657 465.533 69.5597 465.212 69.3443C464.89 69.1288 464.512 69.0138 464.125 69.0138C463.612 69.0116 463.118 69.2131 462.752 69.5741C462.387 69.9351 462.179 70.4263 462.175 70.94V70.94Z",
  fill: "#6F7073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M442.547 85.9101H423.56V88.1924H442.547V85.9101Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M458.74 85.9101H445.297V88.1924H458.74V85.9101Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.74 85.91H414.01V88.1923H419.74V85.91Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M432.746 94.8122H429.509V97.0945H432.746V94.8122Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M454.966 94.8122H434.489V97.0945H454.966V94.8122Z",
  fill: "url(#paint0_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427.768 94.8119H421.342V97.0943H427.768V94.8119Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M437.132 103.701H431.118V105.983H437.132V103.701Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.548 103.701H440.456V105.983H443.548V103.701Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M429.379 103.701H421.342V105.983H429.379V103.701Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M424.871 112.602H420.169V114.884H424.871V112.602Z",
  fill: "url(#paint1_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.429 112.602H414.01V114.884H418.429V112.602Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M432.763 121.503H427.332V123.785H432.763V121.503Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M451.588 121.503H435.928V123.785H451.588V121.503Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.429 121.503H421.342V123.785H425.429V121.503Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M429.819 130.391H426.137V132.673H429.819V130.391Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M439.778 130.391H431.862V132.673H439.778V130.391Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M424.409 130.391H421.342V132.673H424.409V130.391Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.364 139.292H430.981V141.575H434.364V139.292Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M451.765 139.292H436.541V141.575H451.765V139.292Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M428.09 139.292H421.073V141.575H428.09V139.292Z",
  fill: "url(#paint2_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.139 148.181H422.35V150.463H431.139V148.181Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M420.768 148.181H414.01V150.463H420.768V148.181Z",
  fill: "#FFA600",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d_11_498)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 468.68,
  cy: 152.993,
  r: 20,
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 468.677,
  cy: 152.992,
  r: 16.6667,
  fill: "#1A1D1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.063 163.319C467.912 163.319 467.796 163.266 467.713 163.159C467.631 163.067 467.59 162.944 467.59 162.791V161.185C466.59 161.093 465.747 160.841 465.062 160.428C464.377 159.999 463.856 159.487 463.5 158.89C463.144 158.293 462.952 157.658 462.925 156.985C462.925 156.863 462.966 156.756 463.048 156.664C463.144 156.557 463.254 156.503 463.377 156.503H464.446C464.596 156.503 464.713 156.549 464.795 156.641C464.877 156.733 464.932 156.84 464.959 156.962C465.042 157.329 465.213 157.697 465.473 158.064C465.734 158.416 466.103 158.714 466.583 158.959C467.076 159.188 467.707 159.303 468.474 159.303C469.652 159.303 470.515 159.073 471.063 158.614C471.625 158.14 471.906 157.513 471.906 156.733C471.906 156.197 471.755 155.769 471.454 155.447C471.166 155.111 470.721 154.813 470.118 154.552C469.515 154.292 468.734 154.009 467.775 153.703C466.775 153.382 465.946 153.03 465.288 152.648C464.631 152.265 464.137 151.791 463.809 151.225C463.493 150.659 463.336 149.94 463.336 149.067C463.336 147.951 463.706 146.994 464.446 146.199C465.186 145.388 466.234 144.914 467.59 144.776V143.192C467.59 143.039 467.631 142.917 467.713 142.825C467.796 142.718 467.912 142.665 468.063 142.665H468.844C468.981 142.665 469.09 142.718 469.173 142.825C469.268 142.917 469.316 143.039 469.316 143.192V144.799C470.234 144.921 471.002 145.204 471.618 145.648C472.235 146.092 472.701 146.604 473.016 147.186C473.331 147.767 473.495 148.333 473.509 148.884C473.509 148.991 473.475 149.098 473.406 149.205C473.338 149.297 473.228 149.343 473.077 149.343H471.988C471.892 149.343 471.789 149.312 471.68 149.251C471.584 149.19 471.509 149.075 471.454 148.907C471.372 148.28 471.056 147.752 470.508 147.323C469.96 146.895 469.248 146.681 468.371 146.681C467.48 146.681 466.754 146.872 466.193 147.254C465.644 147.637 465.37 148.234 465.37 149.045C465.37 149.565 465.501 150.001 465.761 150.353C466.021 150.689 466.432 150.988 466.994 151.248C467.556 151.508 468.289 151.783 469.193 152.074C470.289 152.41 471.187 152.77 471.885 153.152C472.584 153.52 473.098 153.986 473.427 154.552C473.769 155.103 473.941 155.815 473.941 156.687C473.941 157.544 473.749 158.301 473.365 158.959C472.995 159.601 472.461 160.114 471.762 160.496C471.077 160.879 470.262 161.116 469.316 161.208V162.791C469.316 162.944 469.268 163.067 469.173 163.159C469.09 163.266 468.981 163.319 468.844 163.319H468.063Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.557 163.319C468.406 163.319 468.29 163.266 468.208 163.159C468.125 163.067 468.084 162.944 468.084 162.791V161.185C467.084 161.093 466.241 160.841 465.556 160.428C464.871 159.999 464.351 159.487 463.994 158.89C463.638 158.293 463.446 157.658 463.419 156.985C463.419 156.863 463.46 156.756 463.542 156.664C463.638 156.557 463.748 156.503 463.871 156.503H464.94C465.09 156.503 465.207 156.549 465.289 156.641C465.371 156.733 465.426 156.84 465.454 156.962C465.536 157.329 465.707 157.697 465.967 158.064C466.228 158.416 466.598 158.714 467.077 158.959C467.57 159.188 468.201 159.303 468.968 159.303C470.146 159.303 471.009 159.073 471.557 158.614C472.119 158.14 472.4 157.513 472.4 156.733C472.4 156.197 472.249 155.769 471.948 155.447C471.66 155.111 471.215 154.813 470.612 154.552C470.009 154.292 469.228 154.009 468.269 153.703C467.269 153.382 466.44 153.03 465.782 152.648C465.125 152.265 464.632 151.791 464.303 151.225C463.988 150.659 463.83 149.94 463.83 149.067C463.83 147.951 464.2 146.994 464.94 146.199C465.68 145.388 466.728 144.914 468.084 144.776V143.192C468.084 143.039 468.125 142.917 468.208 142.825C468.29 142.718 468.406 142.665 468.557 142.665H469.338C469.475 142.665 469.584 142.718 469.667 142.825C469.763 142.917 469.811 143.039 469.811 143.192V144.799C470.729 144.921 471.496 145.204 472.112 145.648C472.729 146.092 473.195 146.604 473.51 147.186C473.825 147.767 473.989 148.333 474.003 148.884C474.003 148.991 473.969 149.098 473.9 149.205C473.832 149.297 473.722 149.343 473.572 149.343H472.482C472.386 149.343 472.284 149.312 472.174 149.251C472.078 149.19 472.003 149.075 471.948 148.907C471.866 148.28 471.551 147.752 471.003 147.323C470.455 146.895 469.742 146.681 468.865 146.681C467.975 146.681 467.248 146.872 466.687 147.254C466.139 147.637 465.865 148.234 465.865 149.045C465.865 149.565 465.995 150.001 466.255 150.353C466.515 150.689 466.926 150.988 467.488 151.248C468.05 151.508 468.783 151.783 469.687 152.074C470.783 152.41 471.681 152.77 472.38 153.152C473.078 153.52 473.592 153.986 473.921 154.552C474.263 155.103 474.435 155.815 474.435 156.687C474.435 157.544 474.243 158.301 473.859 158.959C473.489 159.601 472.955 160.114 472.256 160.496C471.571 160.879 470.756 161.116 469.811 161.208V162.791C469.811 162.944 469.763 163.067 469.667 163.159C469.584 163.266 469.475 163.319 469.338 163.319H468.557Z",
  fill: "url(#paint3_linear_11_498)"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_d_11_498)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 234.592,
  y: 92.9161,
  width: 85.4112,
  height: 66.3376,
  rx: 3.5,
  fill: "#272A2E",
  stroke: "url(#paint4_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M235.311 146.223L319.438 146.223",
  stroke: "url(#paint5_linear_11_498)",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.063 153.491H277.114C276.583 153.491 276.153 152.98 276.153 152.349C276.153 151.717 276.583 151.207 277.114 151.207H279.063C279.594 151.207 280.023 151.717 280.023 152.349C280.023 152.98 279.594 153.491 279.063 153.491Z",
  fill: "white",
  fillOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.313 120.372C282.366 120.372 276.715 114.72 276.715 107.774V92.9085C276.715 92.5821 276.98 92.317 277.306 92.317H292.163C292.367 92.317 292.558 92.4229 292.667 92.5991C292.667 92.5992 292.667 92.5993 292.667 92.5994L301.823 107.462C301.823 107.463 301.823 107.463 301.823 107.463C301.88 107.557 301.911 107.665 301.911 107.774C301.911 114.72 296.259 120.372 289.313 120.372Z",
  fill: "#272A2E",
  stroke: "url(#paint6_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M300.711 107.942L300.714 108.077C300.875 114.884 306.463 120.372 313.308 120.372C320.254 120.372 325.906 114.72 325.906 107.774C325.906 107.603 325.833 107.444 325.709 107.335L325.706 107.333L308.947 92.4677L300.711 107.942ZM300.711 107.942L300.64 107.827M300.711 107.942L300.64 107.827M300.64 107.827L291.643 93.2208M300.64 107.827L291.643 93.2208M291.643 93.2208C291.643 93.2206 291.643 93.2204 291.642 93.2202M291.643 93.2208L291.642 93.2202M291.642 93.2202C291.53 93.0358 291.526 92.8069 291.63 92.6215C291.734 92.4342 291.932 92.3183 292.146 92.3183H308.555C308.698 92.3183 308.838 92.3711 308.947 92.4674L291.642 93.2202Z",
  fill: "#272A2E",
  stroke: "url(#paint7_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.77 107.465L252.77 107.464L261.926 92.5991C262.034 92.424 262.225 92.3171 262.431 92.3171H277.287C277.613 92.3171 277.879 92.5822 277.879 92.9086V107.774C277.879 114.72 272.227 120.372 265.281 120.372C258.334 120.372 252.683 114.72 252.683 107.774C252.683 107.663 252.713 107.556 252.77 107.465Z",
  fill: "#272A2E",
  stroke: "url(#paint8_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.642 92.4661L245.643 92.4654C245.75 92.3698 245.889 92.317 246.035 92.317H262.444C262.657 92.317 262.855 92.4329 262.96 92.6201C263.064 92.8059 263.06 93.0358 262.948 93.2185C262.948 93.2187 262.947 93.2188 262.947 93.2189L253.95 107.826L253.879 107.941L253.875 108.076C253.714 114.884 248.126 120.372 241.281 120.372C234.334 120.372 228.683 114.72 228.683 107.774C228.683 107.604 228.756 107.443 228.881 107.331C228.881 107.331 228.881 107.331 228.881 107.331L245.642 92.4661Z",
  fill: "#272A2E",
  stroke: "url(#paint9_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.326 108.866H229.274C228.672 108.866 228.183 108.377 228.183 107.775C228.183 107.172 228.672 106.683 229.274 106.683H325.326C325.929 106.683 326.417 107.172 326.417 107.775C326.417 108.377 325.929 108.866 325.326 108.866Z",
  fill: "url(#paint10_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M258.287 78.0441H251.07C248.37 78.0441 246.173 80.3275 246.173 83.1349V90.7295C246.173 91.332 246.643 91.821 247.223 91.821H277.083C273.908 91.7745 270.912 90.9926 268.256 89.638H248.273V83.1349C248.273 81.5314 249.528 80.2271 251.07 80.2271H259.157C258.826 79.5209 258.535 78.7922 258.287 78.0441ZM286.51 89.638H306.496V83.1349C306.496 81.5314 305.242 80.2271 303.699 80.2271H295.61C295.94 79.5209 296.231 78.7922 296.479 78.0441H303.699C306.399 78.0441 308.596 80.3275 308.596 83.1349V90.7295C308.596 91.332 308.126 91.821 307.546 91.821H277.684C280.858 91.7745 283.855 90.9926 286.51 89.638Z",
  fill: "white",
  fillOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.732 84.7418C279.732 86.0869 278.641 87.1773 277.296 87.1773C275.95 87.1773 274.86 86.0869 274.86 84.7418C274.86 83.3968 275.95 82.3064 277.296 82.3064C278.641 82.3064 279.732 83.3968 279.732 84.7418Z",
  fill: "url(#paint11_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.731 58.1429C279.731 59.4879 278.641 60.5783 277.295 60.5783C275.95 60.5783 274.859 59.4879 274.859 58.1429C274.859 56.7978 275.95 55.7074 277.295 55.7074C278.641 55.7074 279.731 56.7978 279.731 58.1429Z",
  fill: "url(#paint12_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.732 52.1893C279.732 53.5344 278.642 54.6248 277.296 54.6248C275.951 54.6248 274.86 53.5344 274.86 52.1893C274.86 50.8443 275.951 49.7539 277.296 49.7539C278.642 49.7539 279.732 50.8443 279.732 52.1893Z",
  fill: "url(#paint13_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M263.086 61.7805C263.086 63.1256 261.995 64.2159 260.65 64.2159C259.304 64.2159 258.214 63.1256 258.214 61.7805C258.214 60.4354 259.304 59.3451 260.65 59.3451C261.995 59.3451 263.086 60.4354 263.086 61.7805Z",
  fill: "url(#paint14_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.942 64.2159C292.596 64.2159 291.506 63.1256 291.506 61.7805C291.506 60.4354 292.596 59.3451 293.942 59.3451C295.287 59.3451 296.378 60.4354 296.378 61.7805C296.378 63.1256 295.287 64.2159 293.942 64.2159Z",
  fill: "url(#paint15_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.757 85.3582C265.757 86.7033 264.667 87.7936 263.321 87.7936C261.976 87.7936 260.885 86.7033 260.885 85.3582C260.885 84.0132 261.976 82.9228 263.321 82.9228C264.667 82.9228 265.757 84.0132 265.757 85.3582Z",
  fill: "url(#paint16_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.244 87.7936C289.899 87.7936 288.808 86.7033 288.808 85.3582C288.808 84.0132 289.899 82.9228 291.244 82.9228C292.59 82.9228 293.68 84.0132 293.68 85.3582C293.68 86.7033 292.59 87.7936 291.244 87.7936Z",
  fill: "url(#paint17_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M277.296 83.6994C284.023 83.6994 289.476 78.2475 289.476 71.5222C289.476 64.797 284.023 59.3451 277.296 59.3451C270.569 59.3451 265.116 64.797 265.116 71.5222C265.116 78.2475 270.569 83.6994 277.296 83.6994ZM277.296 85.7289C285.144 85.7289 291.506 79.3684 291.506 71.5222C291.506 63.6761 285.144 57.3155 277.296 57.3155C269.448 57.3155 263.086 63.6761 263.086 71.5222C263.086 79.3684 269.448 85.7289 277.296 85.7289Z",
  fill: "url(#paint18_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M277.296 89.788C287.386 89.788 295.566 81.6101 295.566 71.5222C295.566 61.4343 287.386 53.2565 277.296 53.2565C267.206 53.2565 259.026 61.4343 259.026 71.5222C259.026 81.6101 267.206 89.788 277.296 89.788ZM277.296 91.8175C288.507 91.8175 297.596 82.731 297.596 71.5222C297.596 60.3135 288.507 51.227 277.296 51.227C266.084 51.227 256.996 60.3135 256.996 71.5222C256.996 82.731 266.084 91.8175 277.296 91.8175Z",
  fill: "url(#paint19_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.236 67.2107H275.336L279.509 73.0967V67.2107H281.356V75.8337H279.256L275.083 69.8548V75.8337H273.236V67.2107Z",
  fill: "url(#paint20_linear_11_498)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_d_11_498)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M150.331 99.754H97.8794C96.933 99.7468 96.0277 99.3657 95.3611 98.6939C94.6944 98.0221 94.3203 97.1139 94.3203 96.1675V68.3337C94.3221 67.3884 94.697 66.4821 95.3635 65.8117C96.03 65.1414 96.9341 64.7613 97.8794 64.754H150.331C151.281 64.7558 152.192 65.1345 152.863 65.8069C153.534 66.4794 153.911 67.3906 153.911 68.3406V96.1675C153.911 97.1175 153.534 98.0287 152.863 98.7011C152.192 99.3735 151.281 99.7522 150.331 99.754Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.8813 99.254L150.33 99.254L150.331 99.254M97.8813 99.254L150.331 64.754C151.281 64.7558 152.192 65.1345 152.863 65.8069C153.534 66.4794 153.911 67.3906 153.911 68.3406V96.1675C153.911 97.1175 153.534 98.0287 152.863 98.7011C152.192 99.3735 151.281 99.7522 150.331 99.754V99.254M97.8813 99.254C97.0675 99.2473 96.2893 98.9194 95.716 98.3417C95.1422 97.7635 94.8203 96.982 94.8203 96.1675V68.3342C94.822 67.5209 95.1446 66.7411 95.7181 66.1643C96.2912 65.5878 97.0686 65.2607 97.8814 65.254H150.331M97.8813 99.254C97.882 99.254 97.8826 99.254 97.8832 99.254L97.8794 99.754L150.331 65.254M150.331 99.254C151.149 99.2522 151.932 98.9264 152.509 98.3479C153.087 97.7692 153.411 96.985 153.411 96.1675V68.3406C153.411 67.523 153.087 66.7388 152.509 66.1602C151.932 65.5816 151.148 65.2557 150.331 65.254M150.331 99.254L150.331 65.254",
  stroke: "white",
  strokeOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.885 75.549H147.526",
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.885 82.254H147.526",
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.885 88.9588H147.526",
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.604 92.3469C115.16 92.3469 119.663 87.8279 119.663 82.2534C119.663 76.679 115.16 72.16 109.604 72.16C104.049 72.16 99.5458 76.679 99.5458 82.2534C99.5458 87.8279 104.049 92.3469 109.604 92.3469Z",
  fill: "white",
  fillOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.121 83.3683C107.731 83.9991 108.562 84.3683 109.439 84.3978C109.521 84.3874 109.604 84.3874 109.687 84.3978C110.575 84.3668 111.415 83.9881 112.026 83.3433C112.638 82.6986 112.971 81.8394 112.955 80.9511C112.938 80.0628 112.574 79.2164 111.939 78.5945C111.305 77.9726 110.451 77.6249 109.563 77.6265C107.681 77.6265 106.172 79.1461 106.172 81.0173C106.171 81.8945 106.512 82.7375 107.121 83.3683ZM112.937 85.3236C111.092 84.089 108.053 84.089 106.195 85.3236C103.292 87.2767 100.369 92.3476 109.647 92.3476C118.926 92.3476 115.827 87.257 112.937 85.3236Z",
  fill: "url(#paint21_linear_11_498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.331 159.246H97.8794C96.933 159.239 96.0277 158.858 95.3611 158.186C94.6944 157.514 94.3203 156.606 94.3203 155.66V127.826C94.3221 126.881 94.697 125.975 95.3635 125.304C96.03 124.634 96.9341 124.254 97.8794 124.246H150.331C151.281 124.248 152.192 124.627 152.863 125.299C153.534 125.972 153.911 126.883 153.911 127.833V155.66C153.911 156.61 153.534 157.521 152.863 158.194C152.192 158.866 151.281 159.245 150.331 159.246Z",
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.8813 158.746L150.33 158.746L150.331 158.746M97.8813 158.746L150.331 124.246C151.281 124.248 152.192 124.627 152.863 125.299C153.534 125.972 153.911 126.883 153.911 127.833V155.66C153.911 156.61 153.534 157.521 152.863 158.194C152.192 158.866 151.281 159.245 150.331 159.246V158.746M97.8813 158.746C97.0675 158.74 96.2893 158.412 95.716 157.834C95.1422 157.256 94.8203 156.474 94.8203 155.66V127.827C94.822 127.013 95.1446 126.233 95.7181 125.657C96.2912 125.08 97.0686 124.753 97.8814 124.746H150.331M97.8813 158.746C97.882 158.746 97.8826 158.746 97.8832 158.746L97.8794 159.246L150.331 124.746M150.331 158.746C151.149 158.745 151.932 158.419 152.509 157.84C153.087 157.262 153.411 156.477 153.411 155.66V127.833C153.411 127.015 153.087 126.231 152.509 125.653C151.932 125.074 151.148 124.748 150.331 124.746M150.331 158.746L150.331 124.746",
  stroke: "white",
  strokeOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.885 135.041H147.526",
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.885 141.746H147.526",
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.885 148.451H147.526",
  stroke: "white",
  strokeOpacity: 0.08,
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.604 151.839C115.16 151.839 119.663 147.32 119.663 141.746C119.663 136.171 115.16 131.652 109.604 131.652C104.049 131.652 99.5458 136.171 99.5458 141.746C99.5458 147.32 104.049 151.839 109.604 151.839Z",
  fill: "white",
  fillOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.121 142.861C107.731 143.492 108.562 143.861 109.439 143.89C109.521 143.88 109.604 143.88 109.687 143.89C110.575 143.859 111.415 143.481 112.026 142.836C112.638 142.191 112.971 141.332 112.955 140.444C112.938 139.555 112.574 138.709 111.939 138.087C111.305 137.465 110.451 137.117 109.563 137.119C107.681 137.119 106.172 138.639 106.172 140.51C106.171 141.387 106.512 142.23 107.121 142.861ZM112.937 144.816C111.092 143.581 108.053 143.581 106.195 144.816C103.292 146.769 100.369 151.84 109.647 151.84C118.926 151.84 115.827 146.749 112.937 144.816Z",
  fill: "url(#paint22_linear_11_498)"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_11_498",
  x: 151.024,
  y: 70.4472,
  width: 252.551,
  height: 83.1063,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_498"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_498",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_11_498",
  x: 151.024,
  y: 70.447,
  width: 252.551,
  height: 83.1063,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_498"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_498",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_11_498",
  x: 352.511,
  y: 14.6015,
  width: 184.168,
  height: 206.391,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_498"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_498",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d_11_498",
  x: 424.564,
  y: 108.877,
  width: 88.2308,
  height: 88.2308,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12.0577
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_498"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_498",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_d_11_498",
  x: 212.183,
  y: 33.7539,
  width: 130.235,
  height: 142,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_498"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_498",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_d_11_498",
  x: 46.3203,
  y: 16.754,
  width: 155.591,
  height: 190.492,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_498"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_498",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_11_498",
  x1: 434.489,
  y1: 95.9533,
  x2: 454.966,
  y2: 95.9533,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_11_498",
  x1: 420.169,
  y1: 113.743,
  x2: 424.871,
  y2: 113.743,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_11_498",
  x1: 421.073,
  y1: 140.434,
  x2: 428.09,
  y2: 140.434,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_11_498",
  x1: 463.419,
  y1: 152.992,
  x2: 474.435,
  y2: 152.992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_11_498",
  x1: 234.092,
  y1: 126.085,
  x2: 320.503,
  y2: 126.085,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_11_498",
  x1: 235.311,
  y1: 146.723,
  x2: 319.438,
  y2: 146.723,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_11_498",
  x1: 276.215,
  y1: 106.344,
  x2: 302.411,
  y2: 106.344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_11_498",
  x1: 291.055,
  y1: 106.345,
  x2: 326.406,
  y2: 106.345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_11_498",
  x1: 252.183,
  y1: 106.344,
  x2: 278.379,
  y2: 106.344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_11_498",
  x1: 228.183,
  y1: 106.344,
  x2: 263.535,
  y2: 106.344,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_11_498",
  x1: 228.183,
  y1: 107.775,
  x2: 326.417,
  y2: 107.775,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_11_498",
  x1: 256.996,
  y1: 70.7857,
  x2: 297.596,
  y2: 70.7857,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_11_498",
  x1: 103.351,
  y1: 84.987,
  x2: 115.856,
  y2: 84.987,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_11_498",
  x1: 103.351,
  y1: 144.479,
  x2: 115.856,
  y2: 144.479,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})));

function SvgNitron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 223,
    viewBox: "0 0 550 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitron);
export default __webpack_public_path__ + "static/media/Nitron.349ad7b8ec2c4843a423c362c29b6cb3.svg";
export { ForwardRef as ReactComponent };